module.exports = __webpack_public_path__ + "static/media/03-4-recption-.01382858.webp";